import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Droppable } from 'react-beautiful-dnd';
import TaskView from './TaskView';
import { IdeaBoxEntry, TaskType } from 'konect-model';
import { DropType } from './GlyphGroupingTable';
import { nanoid } from 'nanoid';
import "./Backlog.css";
import { GlyphEventService } from '../../services/event-service';
import { MDBIcon } from 'mdb-react-ui-kit';

interface BacklogProps {
  entries: IdeaBoxEntry[];
  name: string;
  type: TaskType;
  animateToRef?: any;
  onHover?: (entry: IdeaBoxEntry, hover: boolean) => void;
}

const Title = styled.h3`
position: absolute;
padding: 0.2rem 0.4rem;
margin-top: 0.5rem;
font-size: 1rem;
text-align: center;
z-index: 1;
border-radius: 1rem;
`;

const TaskList2 = styled.div`
  transition: background-color 0.2s ease;
  background-color: ${(props: any) => (props.isDraggingOver ? 'rgba(0,0,0,0.1)' : 'inherit')};
  flex-grow: 1;
  padding-top: 2.5rem;
  overflow-x: hidden;
`;

export default function Backlog(props: BacklogProps) {
  const [collapse, setCollapse] = useState(false);
  const [dim, setDim] = useState({});

  useEffect(() => {
    if (!props.animateToRef) {
        return;
    }
    const subscriptionId = GlyphEventService.on("HIGHLIGHT_ENTRY", (id: string) => {
      if (!id) {
        setDim({});
        return;
      }
      setDim({ backgroundColor: "rgba(0,0,0,0.1)" });
    });

    return () => {
        GlyphEventService.off("HIGHLIGHT_ENTRY", subscriptionId);
    };
  }, [props.entries]); // eslint-disable-line react-hooks/exhaustive-deps

  const entryElements: JSX.Element[] = [];

  for (let i = 0; i < props.entries.length; i++) {
    const entry = props.entries[i];
    if (entry.type !== props.type) {
      continue;
    }
    entryElements.push(<TaskView key={entry.id}
      entry={entry}
      index={props.entries.findIndex((e: IdeaBoxEntry) => e.id === entry.id)}
      animateToRef={props.animateToRef}
      onHover={props.onHover} />)
  }

  return !props.animateToRef || entryElements.length > 0 ? <div className={`backlog border ${props.type}`} style={collapse ? { minWidth: "0", width: "2.75rem" } : {}}>
    {!collapse &&
      <Title className={"text-center " + props.type}>
        {props.name}</Title>}
    {!collapse &&
      <Droppable droppableId={"backlog" + nanoid()} type={DropType.TASK}>
        {(provided: any, snapshot: any) =>
          <TaskList2
            ref={provided.innerRef}
            {...provided.droppableProps}
            isDraggingOver={snapshot.isDraggingOver}
            style={dim}
          >
            {entryElements}
            {provided.placeholder}
          </TaskList2>
        }
      </Droppable>

    }
    <span className="d-flex accept-modal-button" onClick={() => setCollapse(!collapse)} style={{ borderColor: "transparent", position: "absolute", left: "0.5rem", top: "0.5rem" }}>
      {collapse ? <MDBIcon fas icon='caret-right' style={{ transform: "translateX(25%) scale(1.5)" }} /> : <MDBIcon fas icon='caret-down' style={{ transform: "scale(1.5)" }} />}
    </span>
  </div> : null
}